const { ENTITY_TYPE } = require('../../constants/featureFlags')
const { NOTIFICATIONS_TYPE } = require('../../constants/notificationsConstants')
const { jobStatusType } = require('../../js/constants')
angular
  .module('surfsightApp.controllers')
  .controller('healthReportsAlarmsController', [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$timeout',
    '$interval',
    '$location',
    '$window',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$sce',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    '$mdMedia',
    'edgeFactory',
    'edgeGroupFactory',
    'broadcastViewFactory',
    'leafletData',
    'leafletBoundsHelpers',
    'SystemConstants',
    'UnitSystem',
    'NgTableParams',
    '$q',
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $timeout,
      $interval,
      $location,
      $window,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $sce,
      $mdSidenav,
      $mdToast,
      $mdColors,
      $mdMedia,
      edgeFactory,
      edgeGroupFactory,
      broadcastViewFactory,
      leafletData,
      leafletBoundsHelpers,
      SystemConstants,
      UnitSystem,
      NgTableParams,
      $q
    ) {
      const ALARM_REPORT_HEADERS = [
        'Severity',
        'Name',
        'IMEI',
        'Created At',
        'Alarm',
        'Recommendations'
      ]

      const ALARM_BETA_REPORT_HEADERS = [
        'IMEI',
        'Device Name',
        'Alarm Name',
        'Created Date',
        'Alarm status',
        'Simulated',
        'Recommendation'
      ]

      const ALARMS_BETA_REQ_PARAMS_MAP = {
        alarmBetaDefinitionName: 'alarmDefinitionName',
        deviceBetaName: 'deviceName',
        imei: 'serialNumber'
      }
      $scope.userOrganization = $localStorage.userOrganization
      $scope.currentTab = 0
      $scope.loading = false
      const showMessageToast = message => {
        const toast = $mdToast
          .simple()
          .textContent(message)
          .action('ok')
          .position('top right')
          .hideDelay(10000)

        $mdToast
          .show(toast)
          .then(() => {})
          .catch(() => {})
      }
      let tableApiRequestTimeout = null
      const initialPageSize = 100
      $scope.data = {
        availableSeverity: [
          {
            name: 'Fatal',
            value: 60
          },
          {
            name: 'Error',
            value: 50
          },
          {
            name: 'Warn',
            value: 40
          },
          {
            name: 'Info',
            value: 30
          },
          {
            name: 'Debug',
            value: 20
          },
          {
            name: 'Trace',
            value: 10
          }
        ],
        availableAlarmStates: [
          {
            name: 'Active',
            value: 'active'
          },
          {
            name: 'Inactive',
            value: 'inactive'
          },
          {
            name: 'Closed',
            value: 'closed'
          }
        ]
      }
      const processAlarmsData = (alarms, version) => {
        if (version !== 'alarms-beta') {
          return alarms.map(alarm => {
            const alarmDefinition = $scope.staticData.alarmDefinitions.find(
              ad => ad.id === alarm.alarmDefinitionId
            )
            const severity = $scope.data.availableSeverity.find(
              s => s.value === alarmDefinition.severity
            )
            alarm.createdAt = new Date(alarm.createdAt).toString()
            return {
              ...alarm,
              readStatus: !!alarm.lastReadAt,
              closeStatus: !!alarm.lastCloseAt,
              createdAtText: moment(alarm.createdAt).format('lll'),
              severity,
              alarmName: alarmDefinition.name,
              recommendation: alarmDefinition.recommendation
            }
          })
        }
        return alarms.map(alarm => {
          return {
            ...alarm,
            createdAt: moment(alarm.createdAt).format('lll'),
            readStatus: !!alarm.lastReadAt || !!alarm.lastCloseAt,
            closeStatus: !!alarm.lastCloseAt,
            alarmName: alarm.alarmDefinition.name,
            recommendation: alarm.alarmDefinition.recommendation,
            isSimulated: alarm.details.includes('simulated') ? 'True' : 'False',
            ...(alarm.alarmDefinition.recommendation.includes('http') && {
              recommendationLink: `http${
                alarm.alarmDefinition.recommendation.split('http')[1]
              }`
            })
          }
        })
      }

      const getAlarmsApiUrl = () => {
        return $scope.currentTab === 1
          ? `${DEVICE_BASEURL}/v1.1/alarms`
          : `${DEVICE_BASEURL}/alarms`
      }

      const getAlarmsVersion = () => {
        return $scope.currentTab === 1 ? 'alarms-beta' : 'alarms'
      }

      const changeRequestParamsForAlarmsBeta = requestQueryParams => {
        Object.keys(ALARMS_BETA_REQ_PARAMS_MAP).forEach(key => {
          if (requestQueryParams.get(key)) {
            requestQueryParams.set(
              ALARMS_BETA_REQ_PARAMS_MAP[key],
              requestQueryParams.get(key)
            )
            requestQueryParams.delete(key)
          }
        })
        return requestQueryParams
      }

      $scope.initializeAlarmReports = async () => {
        $scope.loading = true
        $scope.currentTab = 0
        try {
          const response = await $http({
            method: 'GET',
            url: `${DEVICEMANAGER_BASEURL}/v1/entity-feature-access/alarmsV2FeatureFlag`,
            params: {
              entityId: $localStorage.userOrganization.id,
              entityType: ENTITY_TYPE.ORGANIZATION
            }
          })
          $scope.tabsEnabled =
            response.data && response.data.data && response.data.data.access
        } catch (error) {
          $scope.tabsEnabled = true
        } finally {
          $scope.loading = false
        }
      }
      $scope.resetCurrentReportDownload = () => {
        $scope.downloadStatus = {
          downloadRequestStatus: jobStatusType.INITIAL
        }
      }
      $scope.resetCurrentReportDownload()
      $scope.downloadCurrentReport = () => {
        $scope.downloadStatus.downloadRequestStatus = jobStatusType.IN_QUEUE
        const urlSearchParams = new URLSearchParams($scope.params)
        const queryParamsIterator = urlSearchParams.entries()
        const requestQueryParams = new URLSearchParams('')

        requestQueryParams.set('open', '')
        requestQueryParams.set(
          'organizationId',
          $localStorage.userOrganization.id
        )
        for (const queryParam of queryParamsIterator) {
          const [key, value] = queryParam
          if (key === 'sort') {
            const lastIndex = value.lastIndexOf('-')
            requestQueryParams.set('sort', value.substr(0, lastIndex))
            requestQueryParams.set('order', value.substr(lastIndex + 1))
          } else {
            requestQueryParams.set(key.replace(/grid_search\./, ''), value)
          }
        }
        if (!requestQueryParams.get('sort')) {
          requestQueryParams.set('sort', 'createdAt')
          requestQueryParams.set('order', 'desc')
        }
        if (requestQueryParams.get('device_id')) {
          requestQueryParams.set(
            'serialNumber',
            requestQueryParams.get('device_id')
          )
          requestQueryParams.delete('device_id')
        }
        if (requestQueryParams.get('severity')) {
          requestQueryParams.set(
            'alarmDefinitionSeverity',
            requestQueryParams.get('severity')
          )
          requestQueryParams.delete('severity')
        }
        if (requestQueryParams.get('alarmName')) {
          requestQueryParams.set(
            'alarmDefinitionName',
            requestQueryParams.get('alarmName')
          )
          requestQueryParams.delete('alarmName')
        }
        const isAlarmsV2 = getAlarmsVersion() === 'alarms-beta'
        requestQueryParams.set('isAlarmsV2', isAlarmsV2)
        const updatedRequestQueryParams = changeRequestParamsForAlarmsBeta(
          requestQueryParams
        )

        const requestJson = {
          method: 'GET',
          url: `${DEVICE_BASEURL}/device-alarms-download?${updatedRequestQueryParams.toString()}`,
          timeout: tableApiRequestTimeout
        }

        $http(requestJson)
          .then(res => {
            $scope.downloadStatus.downloadRequestStatus =
              jobStatusType.COMPLETED
            $scope.$emit('reportDownloadRequested', {
              reportType:
                NOTIFICATIONS_TYPE.downloadDevicesAlarmsReport.notificationType
            })
          })
          .catch(error => {
            $scope.downloadStatus.downloadRequestStatus = jobStatusType.FAILED
            if (error.data && error.data.status) {
              return showMessageToast(
                error.data.message
                  ? error.data.message.split(':')[1]
                  : error.data.status.error
              )
            }
            handleServerError(error)
          })
      }

      $scope.data.gridOptions = {
        data: [],
        sort: {
          predicate: 'createdAt',
          direction: 'desc'
        },
        urlSync: true,
        defaultPageSize: initialPageSize,
        pagination: {
          itemsPerPage: initialPageSize
        },
        getData: (params, callback) => {
          tableApiRequestTimeout && tableApiRequestTimeout.resolve()
          $scope.params = params
          const urlSearchParams = new URLSearchParams(params)
          const queryParamsIterator = urlSearchParams.entries()
          let requestQueryParams = new URLSearchParams('')
          requestQueryParams.set(
            'limit',
            urlSearchParams.get('itemsPerPage') ||
              $scope.data.gridOptions.defaultPageSize
          )
          if (getAlarmsVersion() !== 'alarms-beta') {
            requestQueryParams.set('open', '')
          }
          requestQueryParams.set(
            'organizationId',
            $localStorage.userOrganization.id
          )
          for (const queryParam of queryParamsIterator) {
            const [key, value] = queryParam
            if (key === 'page') {
              const limit = requestQueryParams.get('limit')
              const offset = parseInt(limit) * (parseInt(value) - 1)
              offset && requestQueryParams.set('offset', offset)
            } else if (key === 'sort') {
              const lastIndex = value.lastIndexOf('-')
              requestQueryParams.set('sort', value.substr(0, lastIndex))
              requestQueryParams.set('order', value.substr(lastIndex + 1))
            } else {
              requestQueryParams.set(key.replace(/grid_search\./, ''), value)
            }
          }
          if (!requestQueryParams.get('sort')) {
            requestQueryParams.set('sort', 'createdAt')
            requestQueryParams.set('order', 'desc')
          }
          if (requestQueryParams.get('device_id')) {
            requestQueryParams.set(
              'serialNumber',
              requestQueryParams.get('device_id')
            )
            requestQueryParams.delete('device_id')
          }
          if (requestQueryParams.get('severity')) {
            requestQueryParams.set(
              'alarmDefinitionSeverity',
              requestQueryParams.get('severity')
            )
            requestQueryParams.delete('severity')
          }
          if (requestQueryParams.get('alarmName')) {
            requestQueryParams.set(
              'alarmDefinitionName',
              requestQueryParams.get('alarmName')
            )
            requestQueryParams.delete('alarmName')
          }
          if (getAlarmsVersion() === 'alarms-beta') {
            requestQueryParams = changeRequestParamsForAlarmsBeta(
              requestQueryParams
            )
          }
          tableApiRequestTimeout = $q.defer()
          $scope.loading = true
          const requestJson = {
            method: 'GET',
            url: `${getAlarmsApiUrl()}?${requestQueryParams.toString()}`,
            timeout: tableApiRequestTimeout
          }
          $http(requestJson)
            .then(async ({ data: { data, metadata } }) => {
              await loadAlarmDefinitions()
              const alarms = processAlarmsData(data, getAlarmsVersion())
              callback(alarms, metadata.count)
              $scope.data.gridOptions.data = alarms
            })
            .catch(handleServerError)
            .finally(() => {
              $scope.loading = false
              $scope.$applyAsync()
            })
        }
      }
      $scope.tableRefresh = function () {
        // $scope.$broadcast('$locationChangeSuccess', '')
        $scope.data.gridOptions.getData($scope.params, (data, count) => {
          $scope.data.gridOptions.data = data
          $scope.data.gridOptions.totalItems = count
          $scope.$applyAsync()
        })
      }
      $timeout(() => {
        $scope.tableRefresh()
      })
      const tableRefreshInterval = $interval(() => {
        $scope.tableRefresh()
      }, 60 * 1000)
      $scope.staticData = {
        alarmDefinitions: []
      }
      const loadAlarmDefinitions = async () => {
        if ($scope.staticData.alarmDefinitions.length) return
        try {
          const { data } = await $http({
            method: 'GET',
            url: `${DEVICE_BASEURL}/alarm-definitions`
          })
          $scope.staticData.alarmDefinitions = data.data
        } catch (error) {
          handleServerError(error)
        }
      }
      loadAlarmDefinitions()
      $timeout(() => {
        $scope.tableRefresh()
      })
      $scope.grid_search = {}
      $scope.addAlarmAction = async (ev, alarm, type) => {
        let result
        switch (type) {
          case 'read': {
            break
          }
          case 'close': {
            if (getAlarmsVersion() !== 'alarms-beta') {
              const confirm = $mdDialog
                .confirm()
                .title('Are you sure you want to close this alarm ?')
                .ariaLabel('close alarms')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No')
              try {
                const result = await $mdDialog.show(confirm)
                if (!result) return
              } catch (_) {
                return
              }
            } else {
              try {
                $scope.comment = ''
                result = await $mdDialog.show({
                  controller: ['$scope', '$mdDialog', closeAlarmController],
                  template: `
                    <md-dialog aria-label="Close Alarm">
                      <form ng-cloak>
                        <md-dialog-content style="padding: 24px;">
                          <h2 class="md-title">Are you sure you want to close this alarm?</h2>
                          <div style="margin-top: 15px;">
                            <label for="comment-input" style="display: block; margin-bottom: 10px;">Optional: Provide a closing comment.</label>
                            <input
                              autocomplete="off"
                              md-no-asterisk
                              id="comment-input"
                              type="text"
                              ng-model="comment"
                              style="width: 100%; padding: 5px; border: 1px solid #ccc; border-radius: 4px;"
                            />
                          </div>
                        </md-dialog-content>
                        <md-dialog-actions layout="row" style="padding: 16px;">
                          <md-button ng-click="cancel()">No</md-button>
                          <md-button class="md-primary" ng-click="confirm()">Yes</md-button>
                        </md-dialog-actions>
                      </form>
                    </md-dialog>
                  `,
                  targetEvent: ev,
                  clickOutsideToClose: true
                })
                if (!result) break
              } catch (_) {
                return
              }
            }
            break
          }
        }
        const requestJson = {
          method: 'POST',
          url: `${DEVICE_BASEURL}${
            getAlarmsVersion() === 'alarms-beta' ? '/v1.1' : ''
          }/alarms/${alarm.id}/actions`,
          data: {
            type,
            ...(result && {
              comment: result
            })
          }
        }
        $http(requestJson)
          .then(response => {
            let message
            switch (type) {
              case 'read':
                message = 'Alarm marked as Read.'
                break
              case 'close':
                message = 'Alarm closed successfully.'

                break
            }
            showMessageToast(message)
            $scope.tableRefresh()
          })
          .catch(error => {
            if (error.data && error.data.status) {
              return showMessageToast(
                error.data.message
                  ? error.data.message.split(':')[1]
                  : error.data.status.error
              )
            }
            handleServerError(error)
          })
      }
      function closeAlarmController ($scope, $mdDialog) {
        $scope.confirm = function () {
          $mdDialog.hide($scope.comment)
        }

        $scope.cancel = function () {
          $mdDialog.cancel()
        }
      }
      $scope.viewAlarmComments = (ev, alarm) => {
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                alarmId: alarm.id,
                ...$scope.staticData
              }
            },
            controller: [
              '$scope',
              '$mdDialog',
              '$mdToast',
              'dataFromCaller',
              viewAlarmCommentsController
            ],
            templateUrl:
              `./templates/health-reports/health-reports-alarms${
                getAlarmsVersion() === 'alarms-beta' ? '-beta' : ''
              }-comments.view.html?t=` + window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: false // Only for -xs, -sm breakpoints.
          })
          .then(() => {})
          .catch(() => {})
      }
      function viewAlarmCommentsController (
        $scope,
        $mdDialog,
        $mdToast,
        dataFromCaller
      ) {
        const alarmId = dataFromCaller.alarmId
        const alarmsVersion = getAlarmsVersion()

        $scope.alarm = {}
        const loadAlarmData = () => {
          const requestJson = {
            method: 'GET',
            url: `${DEVICE_BASEURL}${
              alarmsVersion === 'alarms-beta' ? '/v1.1' : ''
            }/alarms/${alarmId}`
          }
          $http(requestJson)
            .then(({ data }) => {
              const alarm = data.data
              $scope.alarm = data.data
              const alarmDefinition = dataFromCaller.alarmDefinitions.find(
                ad => ad.id === alarm.alarmDefinitionId
              )
              alarm.comments = alarm.comments.map(alarmComment => {
                return {
                  ...alarmComment,
                  createdAtText: moment(alarmComment.createdAt).format('lll')
                }
              })
              if (alarmsVersion === 'alarms-beta') {
                $scope.alarm = {
                  ...alarm,
                  createdAt: moment(alarm.createdAt).format('lll'),
                  readStatus: !!alarm.lastReadAt,
                  closeStatus: !!alarm.lastCloseAt,
                  alarmName: alarm.alarmDefinition.name,
                  recommendation: alarm.alarmDefinition.recommendation,
                  alarmCloseTimestamp: !!alarmCloseTimestamp
                    ? moment(alarm.alarmCloseTimestamp).format('lll')
                    : null
                }
              } else {
                $scope.alarm = {
                  ...alarm,
                  createdAtText: moment(alarm.createdAt).format('lll'),
                  severity: alarmDefinition.severity,
                  alarmName: alarmDefinition.name,
                  recommendation: alarmDefinition.recommendation
                }
              }
            })
            .catch(error => {
              if (error.data && error.data.status) {
                return showMessageToast(error.data.status.code)
              }
              handleServerError(error)
            })
            .finally(() => {
              $scope.newAlarmComment.submitting = false
            })
        }
        loadAlarmData()
        $scope.alarm = dataFromCaller.alarm
        $scope.newAlarmComment = {
          data: {
            details: ''
          },
          submitting: false
        }
        $scope.addNewAlarmComment = () => {
          const { details } = $scope.newAlarmComment.data
          const comment = details.trim()
          if (!comment)
            return showMessageToast(
              'Please enter your comment',
              angular.element(document.getElementById('new-comment-form'))
            )
          $scope.newAlarmComment.submitting = true
          const requestJson = {
            method: 'POST',
            url: `${DEVICE_BASEURL}${
              getAlarmsVersion() === 'alarms-beta' ? '/v1.1' : ''
            }/alarms/${$scope.alarm.id}/comments`,
            data: {
              details: comment
            }
          }
          $http(requestJson)
            .then(() => {
              $scope.newAlarmComment.data = {
                details: ''
              }
              showMessageToast('Alarm comment added successfully.')
              loadAlarmData()
            })
            .catch(error => {
              if (error.data && (error.data.message || error.data.status)) {
                return showMessageToast(
                  error.data.message.split(':')[1] || error.data.status.error
                )
              }
              handleServerError(error)
            })
            .finally(() => {
              $scope.newAlarmComment.submitting = false
            })
        }
        const showMessageToast = (message, parentContainer = null) => {
          const toast = $mdToast
            .simple()
            .textContent(message)
            .action('ok')
            .parent(
              parentContainer ||
                angular.element(
                  document.getElementById('view-alarms-comments-container')
                )
            )
            .position('bottom left')
            .hideDelay(5000)

          $mdToast
            .show(toast)
            .then(() => {})
            .catch(() => {})
        }
        $scope.cancel = function () {
          $mdDialog.cancel()
        }
      }
      $scope.showAlarmRecipients = ev => {
        $mdDialog
          .show({
            controller: 'healthReportsAlarmsNotificationsController',
            templateUrl:
              './templates/health-reports/health-reports-alarms-notifications.view.html?t=' +
              window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: false // Only for -xs, -sm breakpoints.
          })
          .then(() => {})
          .catch(() => {})
      }
      const handleServerError = error => {
        $scope.$emit('handleServerError', error)
      }
      $scope.changeDateFormat = date => moment(date).format('MMM D YYYY')
      $scope.$on('$destroy', () => {
        $interval.cancel(tableRefreshInterval)
      })
      $scope.$watch('currentTab', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          $scope.grid_search = {}
          const urlSearchParams = new URLSearchParams($location.search())
          const queryParamsIterator = urlSearchParams.entries()
          for (const queryParam of queryParamsIterator) {
            const [key] = queryParam
            if (key.startsWith('grid_search')) {
              urlSearchParams.delete(key)
            }
          }
          $location.search(urlSearchParams.toString())
          $scope.params = {}
          $scope.tableRefresh()
        }
      })
    }
  ])
